import React from 'react'
import MasterLayout from 'views/MasterLayout'
import AdminRouter from './Router'

export default function MainLayout(props) {
  return (
    <MasterLayout>
      <AdminRouter match={props.match}/>
    </MasterLayout>
  )
}
